<template>
    <div class="User">

        <div class="row">

            <div class="col-md-3 backInfoMain">
                <div class="row">
                    <div class="backInfo">
                        <div class="nom">{{getUser.prenom}} {{getUser.nom}}</div>
                        <s-line></s-line>                      
                        <div class="sTitre">{{$t('u_Adress')}}</div>
                        <div class="adress">{{getUser.adress}}</div>
                        <div class="adress">{{getUser.ville}}</div>
                        <div class="adress">{{getUser.codePostal}}</div>
                        <div class="adress">{{getUser.tel}}</div>
                        <s-line></s-line>
                        <div class="sTitre">{{$t('u_Courriel')}}</div>
                        <div class="adress">{{getUser.email}}</div>
                    </div>
                </div>    
            </div>

            <div class="col-md-8 backAutorisation">

                <div role="tablist">
                    <b-card no-body class="mb-1">
                      <b-card-header header-tag="header" :class="Class_bCardHeader" role="tab">
                        <b-button block v-b-toggle.accueil :class="class_bButton">{{$t('m_Accueil')}}</b-button>
                      </b-card-header>
                      <b-collapse id="accueil" visible accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                          <b-card-text>{{ $t('m_Moniteur') }}</b-card-text>
                        </b-card-body>
                      </b-collapse>
                    </b-card>  

                    <b-card no-body class="mb-1">
                      <b-card-header header-tag="header" :class="Class_bCardHeader" role="tab">
                        <b-button block v-b-toggle.portail :class="class_bButton">{{$t('m_Portail')}}</b-button>
                      </b-card-header>
                      <b-collapse id="portail" visible accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                            <b-card-text>{{ $t('m_Telechargement') }}</b-card-text>
                            <b-card-text>{{ $t('m_ActivationDeLicence') }}</b-card-text>
                            <b-card-text>{{ $t('m_DemandeDevelopeur') }}</b-card-text>
                            <b-card-text>{{ $t('m_DetailsClient') }}</b-card-text>
                            <b-card-text>{{ $t('m_Ping') }}</b-card-text>
                            <b-card-text>{{ $t('m_LogDesErreurs') }}</b-card-text>
                        </b-card-body>
                      </b-collapse>
                    </b-card>  

                    <b-card no-body class="mb-1">
                      <b-card-header header-tag="header" :class="Class_bCardHeader" role="tab">
                        <b-button block v-b-toggle.items :class="class_bButton">{{$t('m_Items')}}</b-button>
                      </b-card-header>
                      <b-collapse id="items" visible accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                            <b-card-text>{{ $t('m_Items') }}</b-card-text>
                            <b-card-text>{{ $t('m_Departement') }}</b-card-text>
                            <b-card-text>{{ $t('m_MenuLibre') }}</b-card-text>
                            <b-card-text>{{ $t('m_Categorie') }}</b-card-text>
                            <b-card-text>{{ $t('m_GestionDePrix') }}</b-card-text>
                            <b-card-text>{{ $t('m_Fournisseur') }}</b-card-text>
                            <b-card-text>{{ $t('m_CharteGC') }}</b-card-text>
                            <b-card-text>{{ $t('m_Etiquette') }}</b-card-text>
                            <b-card-text>{{ $t('m_Ingredients') }}</b-card-text>
                        </b-card-body>
                      </b-collapse>
                    </b-card>  

                    <b-card no-body class="mb-1">
                      <b-card-header header-tag="header" :class="Class_bCardHeader" role="tab">
                        <b-button block v-b-toggle.gestionItems :class="class_bButton">{{$t('m_GestionItems')}}</b-button>
                      </b-card-header>
                      <b-collapse id="gestionItems" visible accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                            <b-card-text>{{ $t('m_GestionItems') }}</b-card-text>
                            <b-card-text>{{ $t('m_ComFournisseur') }}</b-card-text>
                            <b-card-text>{{ $t('m_ReceptionCom') }}</b-card-text>
                            <b-card-text>{{ $t('m_PriseInventaire') }}</b-card-text>
                            <b-card-text>{{ $t('m_EcartInventaire') }}</b-card-text>
                            <b-card-text>{{ $t('m_RetroActif') }}</b-card-text>
                        </b-card-body>
                      </b-collapse>
                    </b-card>  

                    <b-card no-body class="mb-1">
                      <b-card-header header-tag="header" :class="Class_bCardHeader" role="tab">
                        <b-button block v-b-toggle.clients :class="class_bButton">{{$t('m_Clients')}}</b-button>
                      </b-card-header>
                      <b-collapse id="clients" visible accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                            <b-card-text>{{ $t('m_Clients') }}</b-card-text>
                            <b-card-text>{{ $t('m_FicheClient') }}</b-card-text>
                            <b-card-text>{{ $t('m_PrixClient') }}</b-card-text>
                            <b-card-text>{{ $t('m_PaiementDeCompte') }}</b-card-text>
                            <b-card-text>{{ $t('m_EtatDeCompte') }}</b-card-text>
                            <b-card-text>{{ $t('m_FusionDeCompte') }}</b-card-text>
                        </b-card-body>
                      </b-collapse>
                    </b-card>  

                    <b-card no-body class="mb-1">
                      <b-card-header header-tag="header" :class="Class_bCardHeader" role="tab">
                        <b-button block v-b-toggle.rapports :class="class_bButton">{{$t('m_Rapports')}}</b-button>
                      </b-card-header>
                      <b-collapse id="rapports" visible accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                            <b-card-text>{{ $t('m_Rapports') }}</b-card-text>
                            <b-card-text>{{ $t('m_Comparatif') }}</b-card-text>
                            <b-card-text>{{ $t('m_VoirFacture') }}</b-card-text>
                            <b-card-text>{{ $t('m_Horodateur') }}</b-card-text>
                            <b-card-text>{{ $t('m_ExportComptable') }}</b-card-text>
                        </b-card-body>
                      </b-collapse>
                    </b-card>  

                    <b-card no-body class="mb-1">
                      <b-card-header header-tag="header" :class="Class_bCardHeader" role="tab">
                        <b-button block v-b-toggle.admin  :class="class_bButton">{{$t('m_Admin')}}</b-button>
                      </b-card-header>
                      <b-collapse id="admin" visible accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                            <b-card-text>{{ $t('m_Admin') }}</b-card-text>
                            <b-card-text>{{ $t('m_Employe') }}</b-card-text>
                            <b-card-text>{{ $t('m_FonctionEmploye') }}</b-card-text>
                            <b-card-text>{{ $t('m_ModeDePaiement') }}</b-card-text>
                            <b-card-text>{{ $t('m_Escompte') }}</b-card-text>
                            <b-card-text>{{ $t('m_CarteCadeaux') }}</b-card-text>
                            <b-card-text>{{ $t('m_Etiquette') }}</b-card-text>
                        </b-card-body>
                      </b-collapse>
                    </b-card>  

                    <b-card no-body class="mb-1">
                      <b-card-header header-tag="header" :class="Class_bCardHeader" role="tab">
                        <b-button block v-b-toggle.config :class="class_bButton">{{$t('m_Configuration')}}</b-button>
                      </b-card-header>
                      <b-collapse id="config" visible accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                            <b-card-text>Vide / Empty</b-card-text>
                        </b-card-body>
                      </b-collapse>
                    </b-card>  
                    
                </div>

            </div>
        </div>
       
    </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default{
    name: "User",
    components: {

    },
    data(){
        return{
            style: 'danger',
            class_bCardHeader: 'p-1',
            class_bButton: 'backAccor'
        }
    },
    mounted() {
    },
        computed: {
        ...mapGetters(['getUser']),
    }
}
</script>

<style lang="scss" scoped>

.backAutorisation{
    background-color: $cContainerBackColor;
    margin-top: 20px;
    margin-left: 5px;
    margin-right: 5px;
    padding-bottom: 20px;
}

.nom{
    margin-top: 5px;
    margin-bottom: -5px;
    font-size: 20px;
    color: $cText;
}
.sTitre{
    margin-top: 0px;
    margin-bottom: 0px;
    font-weight: bold;
    font-size: 15px;
    color: $cText;
    text-align: center;
}
.adress{
    margin-top: 0px;
    margin-bottom: 0px;
    font-size: 15px;
    color: $cText;
    text-align: center;
}
.backAccor{
    color: $cAccordeonTxtColor;
    border: 0px solid $cAccordeonBtnColor;
    background-color: $cAccordeonBtnColor;
}

</style>